import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { JhiItemCount, JhiPagination, Translate, getSortState } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Table } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC, SORT } from 'app/shared/util/pagination.constants';
import { getEntities } from './maintenance-control.reducer';

export const MaintenanceControl = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const maintenanceControlList = useAppSelector(state => state.maintenanceControl.entities);
  const loading = useAppSelector(state => state.maintenanceControl.loading);
  const totalItems = useAppSelector(state => state.maintenanceControl.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.replace(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <PageHeader
        headingId="maintenance-control-heading"
        headingDataCy="MaintenanceControlHeading"
        contentKey="fleetSenseApp.maintenanceControl.home.title"
        buttonTextKey="fleetSenseApp.maintenanceControl.home.createLabel"
        match={match}
      />
      <div className="table-responsive">
        {maintenanceControlList && maintenanceControlList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="fleetSenseApp.maintenanceControl.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('maintenance')}>
                  <Translate contentKey="fleetSenseApp.maintenanceControl.maintenance">Maintenance</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.maintenanceControl.maintenanceReview">Maintenance Review</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.maintenanceControl.truckImplement">Truck Implement</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.maintenanceControl.company">Company</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {maintenanceControlList.map((maintenanceControl, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${maintenanceControl.id}`} color="link" size="sm">
                      {maintenanceControl.id}
                    </Button>
                  </td>
                  <td>{maintenanceControl.maintenance ? 'true' : 'false'}</td>
                  <td>
                    {maintenanceControl.maintenanceReview ? (
                      <Link to={`maintenance-review/${maintenanceControl.maintenanceReview.id}`}>{maintenanceControl.maintenanceReview.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {maintenanceControl.truckImplement ? (
                      <Link to={`truck-implement/${maintenanceControl.truckImplement.id}`}>{maintenanceControl.truckImplement.licensePlate}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{maintenanceControl.company ? <Link to={`company/${maintenanceControl.company.id}`}>{maintenanceControl.company.name}</Link> : ''}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${maintenanceControl.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${maintenanceControl.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${maintenanceControl.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fleetSenseApp.maintenanceControl.home.notFound">No Maintenance Controls found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={maintenanceControlList && maintenanceControlList.length > 0 ? '' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default MaintenanceControl;
